import { Typography } from 'components'
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-left: 0px;
`
const Text = styled(Typography)`
  font-size: ${(props) => props.theme['text-xs']};
  @media (max-width: 426px) {
    font-size: ${(props) => props.theme['text-sm']};
  }
`
function verifyCertificateButton({ children, margin }) {
  return (
    <Link to="/verifyCertificate">
      <Container style={{ margin }}>
        <TextContainer>
          <Text
            id="login.button.verifyCertificate"
            fontSize="text-xxs"
            color="primary1"
            lineHeight={1.3}
            bold
          >
            {children}
          </Text>
        </TextContainer>
      </Container>
    </Link>
  )
}

export default verifyCertificateButton
